/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RejectMakeupRequest
 */
export interface RejectMakeupRequest {
    /**
     * 
     * @type {string}
     * @memberof RejectMakeupRequest
     */
    note: string | null;
}

/**
 * Check if a given object implements the RejectMakeupRequest interface.
 */
export function instanceOfRejectMakeupRequest(value: object): value is RejectMakeupRequest {
    if (!('note' in value) || value['note'] === undefined) return false;
    return true;
}

export function RejectMakeupRequestFromJSON(json: any): RejectMakeupRequest {
    return RejectMakeupRequestFromJSONTyped(json, false);
}

export function RejectMakeupRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): RejectMakeupRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'note': json['note'],
    };
}

export function RejectMakeupRequestToJSON(json: any): RejectMakeupRequest {
    return RejectMakeupRequestToJSONTyped(json, false);
}

export function RejectMakeupRequestToJSONTyped(value?: RejectMakeupRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'note': value['note'],
    };
}

